import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import cx from 'clsx';
import * as React from 'react';

import type { SocialPlayerSharedProps } from '../../SocialPlayerShared/SocialPlayersShared.types';
import semanticClassNames from '../SocialPlayerYoutube.semanticClassNames';
import { TestIds } from '../constants';
import styles from './SocialPlayerYoutube.module.scss';
import { useYoutubeIframe } from './hooks/useYoutubeIframe';

export type SocialPlayerYoutubeProps = SocialPlayerSharedProps;

const SocialPlayerYoutube: React.FC<SocialPlayerYoutubeProps> = props => {
  const {
    id,
    className,
    customClassNames = [],
    description,
    url,
    mute = false,
    autoPlay = false,
    loop = false,
    enabledCaptions = false,
    enabledControls = false,
    startTime = 0,
    endTime = 0,
  } = props;

  const playerElement = React.useRef<null | HTMLIFrameElement>(null);

  const { iframeUrl, aspectRatioStyles } = useYoutubeIframe({
    url,
    mute,
    autoPlay,
    loop,
    enabledCaptions,
    enabledControls,
    startTime,
    endTime,
  });

  return (
    <div
      id={id}
      style={{ display: 'flex', minHeight: 'fit-content' }}
      className={cx(
        className,
        styles.root,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      {...getDataAttributes(props)}
    >
      <iframe
        data-testid={TestIds.viewer.iframe}
        title={description}
        style={aspectRatioStyles}
        src={iframeUrl}
        ref={playerElement}
      ></iframe>
    </div>
  );
};

export default SocialPlayerYoutube;
